<template>
  <div>
    <SupervisionMG />
    <AyudaMG />
    <AvisoSync />
  </div>
</template>

<script>
import AyudaMG from '@extras_mg/components/AyudaMG'
import AvisoSync from '@extras_mg/components/AvisoSync'
import SupervisionMG from '@extras_mg/components/SupervisionMG'

/**
 * Lo que va en todas las páginas con sesión (getAppLayoutComponent del core,
 * que admite un solo componente): la supervisión, el asistente de ayuda y el
 * aviso del cambio de nombre a Sync.
 */
export default {
  name: 'CapaDeLaApp',
  components: { AvisoSync, AyudaMG, SupervisionMG },
}
</script>
